import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, ContentrArea } from '@ttstr/components';

const Faq: React.FC = () => {
  return (
    <article className="my-5">
      <Helmet>
        <body className="faq-page" />
        <title>{'FAQ'}</title>
      </Helmet>
      <Container>
        <ContentrArea id="main" />
      </Container>
    </article>
  );
};

export default React.memo(Faq);
